import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { convertUpdateArguments } from '@angular/compiler/src/compiler_util/expression_converter';
import { elementEventFullName } from '@angular/compiler/src/view_compiler/view_compiler';
import { Inject, ViewChild } from '@angular/core';
import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ItemsList } from '@ng-select/ng-select/lib/items-list';
import { ChatService, ChatServiceToken } from '@pazznetwork/ngx-chat';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { Local } from 'protractor/built/driverProviders';
import swal from 'sweetalert';
import { AticuloModule } from '../../modelo/aticulo/aticulo.module';
import { HojaModule } from '../../modelo/hoja/hoja.module';
import { PeriodoModule } from '../../modelo/hoja/periodo';
import { LocalesModule } from '../../modelo/locales/locales.module';
import { ProductoModule } from '../../modelo/producto/producto.module';
import { versionesModule } from '../../modelo/usuario/versiones';
import { ExcelService } from '../../servicios/excel.service';
import { LoginService } from '../../servicios/login.service';
import { ProducionService } from '../../servicios/producion.service';
import { SignalRAdapter } from './SignalRAdapter';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-hoja',
  templateUrl: './hoja.component.html',
  styleUrls: ['./hoja.component.css']
})
export class HojaComponent implements OnInit {

  listaLocales: LocalesModule[];
  listaProductos: AticuloModule[];
  importHoja: HojaModule[] = [];
  listaProducion: HojaModule[];
  listaProducionLocales: HojaModule[];
  listaProducionConsulta: HojaModule[];
  hoja: HojaModule;
  hojaLocales: HojaModule;
  searchText: string = '';
  fechas: string;
  @ViewChild('lgModal') public lgModal: ModalDirective;
  idLocal: string;
  id_pais: string;
  anio_perio:string;
  nombre: string;
  version: string;
  fecha: string;
  perValor:number;
  fechaHoja: string;
  versionesList: versionesModule[];
  listaPeriodo: PeriodoModule[];
  totalSugerido: number;
  totalDev: number;
  totalLocal: number;
  totalPorcentaje: number;
  ordenarConsulta: boolean;
  totalColor: string;

  totalAmR1:number;
  totalPmR1:number;
  totalAm1:number;
  totalPm1:number;
  totalDev1:number;
  totalAmR2:number;
  totalPmR2:number;
  totalAm2:number;
  totalPm2:number;
  totalDev2:number;
  totalAmR3:number;
  totalPmR3:number;
  totalAm3:number;
  totalPm3:number;
  totalDev3:number;

  totalAmR4:number;
  totalPmR4:number;
  totalAm4:number;
  totalPm4:number;
  totalDev4:number;


  totalAmR5:number;
  totalPmR5:number;
  totalAm5:number;
  totalPm5:number;
  totalDev5:number;


  totalAmR6:number;
  totalPmR6:number;
  totalAm6:number;
  totalPm6:number;
  totalDev6:number;


  totalAmR7:number;
  totalPmR7:number;
  totalAm7:number;
  totalPm7:number;
  totalDev7:number;

  

  anioActual: Date;
  numeral: number;
  title = 'app';
  userId = 999;
  periodoValor: string;
  localNombre:string;
  fileName = 'HojaProduccion.xlsx';

  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;


  previous: any = [];
  constructor(private excelSrv: ExcelService,
    private alertService: AlertService,
    private http: HttpClient, private api: LoginService, private apiHoja: ProducionService, private datepipe: DatePipe) { }

  ngOnInit(): void {

    this.listaProducion = [];

    this.idLocal = localStorage.getItem("id");
    this.id_pais = localStorage.getItem("id_pais");
    this.nombre = localStorage.getItem("nombreLocal");
    this.listarLocales();
    this.buscarProducciones();
    this.buscarPeriodos();
    this.versionesList = [];

  }



  eliminar() {
    if (confirm("Está seguro de eliminar la Hoja de Producciòn")) {
      this.apiHoja.eliminar(this.idLocal, this.id_pais, this.fecha)
        .subscribe((
          data: HojaModule[]) => {
          this.buscarProducciones();
        },
          err => this.alertService.danger('Erro no se puedo eliminar')
        );
    }
  }

  @HostListener('input') oninput() {
    this.searchItems();
  }

  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.listaProducion = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.listaProducion = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

  exportexcel(): void {
    /* pass here the table id */
    let element = document.getElementById('hojaProduccion');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);

  }

  buscar() {

    this.listaPeriodo.forEach(element => {
      if (element.anio.toString() == this.periodoValor) {
        this.fechaHoja = element.fecha;
        this.perValor=element.semana
        this.anio_perio=this.fechaHoja.substring(0,4)+"-"+this.periodoValor
      }
    });

    this.totalDev = 0;
    this.totalPorcentaje = 0;
    this.totalLocal = 0;
    this.totalSugerido = 0;

    this.totalDev=0;  
    this.totalPorcentaje=0;
    this.totalLocal=0;
    this.totalSugerido=0;
    this.totalAm1=0;
    this.totalPm1=0;
    this.totalDev1=0;
    this.totalAmR1=0;
    this.totalPmR1=0;

    this.totalAm2=0;
    this.totalPm2=0;
    this.totalDev2=0;
    this.totalAmR2=0;
    this.totalPmR2=0;
   
   
    this.totalAm3=0;
    this.totalPm3=0;
    this.totalDev3=0;
    this.totalAmR3=0;
    this.totalPmR3=0;
   


    this.totalAm4=0;
    this.totalPm4=0;
    this.totalDev4=0;
    this.totalAmR4=0;
    this.totalPmR4=0;
   


    this.totalAm5=0;
    this.totalPm5=0;
    this.totalDev5=0;
    this.totalAmR5=0;
    this.totalPmR5=0;
   


    this.totalAm6=0;
    this.totalPm6=0;
    this.totalDev6=0;
    this.totalAmR6=0;
    this.totalPmR6=0;
   


    this.totalAm7=0;
    this.totalPm7=0;
    this.totalDev7=0;
    this.totalAmR7=0;
    this.totalPmR7=0;
   

    this.apiHoja.listarProduccionPorLocalxPeriodo(this.idLocal, this.periodoValor, this.id_pais)
      .subscribe((
        data: HojaModule[]) => {
        this.listaProducionConsulta = data;


        this.listaProducionConsulta.forEach(element => {
          this.totalAm1=this.totalAm1+ Number.parseFloat(this.validarNumeros(element.am1));
          this.totalPm1=this.totalPm1+ Number.parseFloat(this.validarNumeros(element.pm1));
          this.totalDev1=this.totalDev1+ Number.parseFloat(this.validarNumeros(element.dev1));
          this.totalAmR1=this.totalAmR1+ Number.parseFloat(this.validarNumeros(element.amval1));
          this.totalPmR1=this.totalPmR1+ Number.parseFloat(this.validarNumeros(element.valpm1));
       

          this.totalAm2=this.totalAm2+ Number.parseFloat(this.validarNumeros(element.am2));
          this.totalPm2=this.totalPm2+ Number.parseFloat(this.validarNumeros(element.pm2));
          this.totalDev2=this.totalDev2+ Number.parseFloat(this.validarNumeros(element.dev2));
          this.totalAmR2=this.totalAmR2+ Number.parseFloat(this.validarNumeros(element.valam2));
          this.totalPmR2=this.totalPmR2+ Number.parseFloat(this.validarNumeros(element.valpm2));
       


          this.totalAm3=this.totalAm3+ Number.parseFloat(this.validarNumeros(element.am3));
          this.totalPm3=this.totalPm3+ Number.parseFloat(this.validarNumeros(element.pm3));
          this.totalDev3=this.totalDev3+ Number.parseFloat(this.validarNumeros(element.dev3));
          this.totalAmR3=this.totalAmR3+ Number.parseFloat(this.validarNumeros(element.amval3));
          this.totalPmR3=this.totalPmR3+ Number.parseFloat(this.validarNumeros(element.valpm3));
       


          this.totalAm4=this.totalAm4+ Number.parseFloat(this.validarNumeros(element.am4));
          this.totalPm4=this.totalPm4+ Number.parseFloat(this.validarNumeros(element.pm4));
          this.totalDev4=this.totalDev4+ Number.parseFloat(this.validarNumeros(element.dev4));
          this.totalAmR4=this.totalAmR4+ Number.parseFloat(this.validarNumeros(element.amval4));
          this.totalPmR4=this.totalPmR4+ Number.parseFloat(this.validarNumeros(element.valpm4));
       



          this.totalAm5=this.totalAm5+ Number.parseFloat(this.validarNumeros(element.am5));
          this.totalPm5=this.totalPm5+ Number.parseFloat(this.validarNumeros(element.pm5));
          this.totalDev5=this.totalDev5+ Number.parseFloat(this.validarNumeros(element.dev5));
          this.totalAmR5=this.totalAmR5+ Number.parseFloat(this.validarNumeros(element.amval5));
          this.totalPmR5=this.totalPmR5+ Number.parseFloat(this.validarNumeros(element.valpm5));
       

          this.totalAm6=this.totalAm6+ Number.parseFloat(this.validarNumeros(element.am6));
          this.totalPm6=this.totalPm6+ Number.parseFloat(this.validarNumeros(element.pm6));
          this.totalDev6=this.totalDev6+ Number.parseFloat(this.validarNumeros(element.dev6));
          this.totalAmR6=this.totalAmR6+ Number.parseFloat(this.validarNumeros(element.amval6));
          this.totalPmR6=this.totalPmR6+ Number.parseFloat(this.validarNumeros(element.valpm6));
      
          

          this.totalAm7=this.totalAm7+ Number.parseFloat(this.validarNumeros(element.am7));
          this.totalPm7=this.totalPm7+ Number.parseFloat(this.validarNumeros(element.pm7));
          this.totalDev7=this.totalDev7+ Number.parseFloat(this.validarNumeros(element.dev7));
          this.totalAmR7=this.totalAmR7+ Number.parseFloat(this.validarNumeros(element.amval7));
          this.totalPmR7=this.totalPmR7+ Number.parseFloat(this.validarNumeros(element.valpm7));


        });



        this.listaProducionConsulta.forEach(element => {
          element.sugerido =
            Number.parseFloat(this.validarNumeros(element.am1)) +
            Number.parseFloat(this.validarNumeros(element.pm1)) +
            Number.parseFloat(this.validarNumeros(element.am2)) +
            Number.parseFloat(this.validarNumeros(element.pm2)) +
            Number.parseFloat(this.validarNumeros(element.am3)) +
            Number.parseFloat(this.validarNumeros(element.pm3)) +
            Number.parseFloat(this.validarNumeros(element.am4)) +
            Number.parseFloat(this.validarNumeros(element.pm4)) +
            Number.parseFloat(this.validarNumeros(element.am5)) +
            Number.parseFloat(this.validarNumeros(element.pm5)) +
            Number.parseFloat(this.validarNumeros(element.am6)) +
            Number.parseFloat(this.validarNumeros(element.pm6)) +
            Number.parseFloat(this.validarNumeros(element.am7)) +
            Number.parseFloat(this.validarNumeros(element.pm7));



          element.local = (
            Number.parseFloat(this.validarNumeros(element.amval1)) +
            Number.parseFloat(this.validarNumeros(element.valpm1)) +
            Number.parseFloat(this.validarNumeros(element.valam2)) +
            Number.parseFloat(this.validarNumeros(element.valpm2)) +
            Number.parseFloat(this.validarNumeros(element.amval3)) +
            Number.parseFloat(this.validarNumeros(element.valpm3)) +
            Number.parseFloat(this.validarNumeros(element.amval4)) +
            Number.parseFloat(this.validarNumeros(element.valpm4)) +
            Number.parseFloat(this.validarNumeros(element.amval5)) +
            Number.parseFloat(this.validarNumeros(element.valpm5)) +
            Number.parseFloat(this.validarNumeros(element.amval6)) +
            Number.parseFloat(this.validarNumeros(element.valpm6)) +
            Number.parseFloat(this.validarNumeros(element.amval7)) +
            Number.parseFloat(this.validarNumeros(element.valpm7))

          );
          element.devolucion = (
            Number.parseFloat(this.validarNumeros(element.dev1)) +
            Number.parseFloat(this.validarNumeros(element.dev2)) +
            Number.parseFloat(this.validarNumeros(element.dev3)) +
            Number.parseFloat(this.validarNumeros(element.dev4)) +
            Number.parseFloat(this.validarNumeros(element.dev5)) +
            Number.parseFloat(this.validarNumeros(element.dev6)) +
            Number.parseFloat(this.validarNumeros(element.dev7))
          );

          this.totalLocal = this.totalLocal + element.local;
          this.totalDev = this.totalDev + element.devolucion;
          this.totalSugerido = this.totalSugerido + element.sugerido;

          if (element.local > 0) {
            element.porcentaje = (element.devolucion / element.local) * 100;
          } else {
            element.porcentaje = 0;

          }

          let valor = element.porcentaje;
          if (valor >= 0 && valor < 10) {
            element.colorPorcentaje = "white"
          }
          if (valor >= 10 && valor < 15) {
            element.colorPorcentaje = "yellow"
          }
          if (valor >= 15 && valor < 30) {
            element.colorPorcentaje = "orange"
          }
          if (valor >= 30) {
            element.colorPorcentaje = "red"
          }

        });

        this.listaProducionConsulta.forEach(element => {
          if (element.sugerido > element.local) {
            element.color = "orange";
          } else {
            element.color = " ";
          }

        });
        if (this.totalLocal > 0) {
          this.totalPorcentaje = (this.totalDev / this.totalLocal) * 100;
        } else {
          this.totalPorcentaje = 0;
        }

        let valor = this.totalPorcentaje;
        if (valor >= 0 && valor < 10) {
          this.totalColor = "white"
        }
        if (valor >= 10 && valor < 15) {
          this.totalColor = "yellow"
        }
        if (valor >= 15 && valor < 30) {
          this.totalColor = "orange"
        }
        if (valor >= 30) {
          this.totalColor = "red"
        }


        this.listaProducionConsulta.forEach(element => {

          //Lunes
          if (element.dev1 == 0) {
            element.dev1 = undefined;
          }
          if (element.amval1 == 0) {
            element.amval1 = undefined;
          }

          if (element.valpm1 == 0) {
            element.valpm1 = undefined;
          }


          //Martes
          if (element.dev2 == 0) {
            element.dev2 = undefined;
          }
          if (element.valam2 == 0) {
            element.valam2 = undefined;
          }

          if (element.valpm2 == 0) {
            element.valpm2 = undefined;
          }

          //Miercoles
          if (element.dev3 == 0) {
            element.dev3 = undefined;
          }
          if (element.amval3 == 0) {
            element.amval3 = undefined;
          }

          if (element.valpm3 == 0) {
            element.valpm3 = undefined;
          }

          //Jueves
          if (element.dev4 == 0) {
            element.dev4 = undefined;
          }
          if (element.amval4 == 0) {
            element.amval4 = undefined;
          }

          if (element.valpm4 == 0) {
            element.valpm4 = undefined;
          }

          //Viernes
          if (element.dev5 == 0) {
            element.dev5 = undefined;
          }
          if (element.amval5 == 0) {
            element.amval5 = undefined;
          }

          if (element.valpm5 == 0) {
            element.valpm5 = undefined;
          }

          //Sabado
          if (element.dev6 == 0) {
            element.dev6 = undefined;
          }
          if (element.amval6 == 0) {
            element.amval6 = undefined;
          }

          if (element.valpm6 == 0) {
            element.valpm6 = undefined;
          }


          //Domingo
          if (element.dev7 == 0) {
            element.dev7 = undefined;
          }
          if (element.amval7 == 0) {
            element.amval7 = undefined;
          }

          if (element.valpm7 == 0) {
            element.valpm7 = undefined;
          }

        });

        this.listaProducionConsulta.sort((a, b) => (a.porcentaje < b.porcentaje) ? 1 : -1)


        this.lgModal.show();


      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
  }

  validarNumeros(numero) {
    if (!numero) {
      return 0;
    } else {
      return numero;
    }
  }

  validarFecha(numero) {
    if (!numero) {
      return '';
    } else {
      return numero;
    }
  }

  grabar() {
    this.fecha = this.validarFecha(this.fecha);
    this.listaProducion.forEach(item => {
      item.id_producion = 0;
      item.id_local = Number.parseInt(this.idLocal);
      item.periodo = 0;
      item.version = this.version;
      item.fecha = this.fecha
      item.id_pais = Number.parseInt(localStorage.getItem("id_pais"));
    });
    this.apiHoja.guardarProduccion(this.listaProducion).subscribe((
      data) => {

      this.alertService.info("Se guardo con exito...")

    },
      err =>
        this.alertService.close(err)
    )
  }

  onChangeLocal($event: Event) {
    this.version = "";
    this.buscarProducciones();
    this.listaLocales.forEach(element => {
        if (element.id.toString()==this.idLocal)
        this.localNombre=element.Nombre_ClientesFinales
    });   

  }



  agregar() {

    this.listaProducion = [];
    this.apiHoja.listarProductos(this.idLocal)
      .subscribe((
        data: AticuloModule[]) => {
        this.listaProductos = data;
        console.log(this.listaLocales);
        this.listaProductos.forEach(item => {
          let hoja = new HojaModule();
          hoja.codigo = item.codigo;
          hoja.id_producion = 0;
          hoja.id_local = Number.parseInt(this.idLocal);
          console.log(hoja.fechafinal);
          hoja.producto = item.Nombre;
          this.listaProducion.push(hoja);

        });

      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
    this.mdbTable.setDataSource(this.listaProducion);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();


  }

  obtenerArticulos() {


    this.apiHoja.listarProductos(this.idLocal)
      .subscribe((
        data: AticuloModule[]) => {
        this.listaProductos = data;
        console.log(this.listaLocales);
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }

  buscarPeriodos() {

    this.apiHoja.listarPeriodoLocalTodos(this.id_pais)
      .subscribe((
        data: PeriodoModule[]) => {
        this.listaPeriodo = data;
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }

  onChangePeriodo($event: Event) {

    this.listaPeriodo.forEach(element => {
      if (element.anio.toString() == this.periodoValor) {
        this.fechaHoja = element.fecha;
        this.perValor=element.semana
         this.anio_perio=this.fechaHoja.substring(0,4)+"-"+this.periodoValor
      }
    });
  

  }


  listarLocales() {


    this.api.locales(this.id_pais)
      .subscribe((
        data: LocalesModule[]) => {
        this.listaLocales = data;
        console.log(this.listaLocales);
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }


  listarVersionesLocales() {


    this.apiHoja.listarVersionxLocal(this.idLocal, this.id_pais)
      .subscribe((
        data: versionesModule[]) => {
        this.versionesList = data;
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }


  onCheckboxOrdenarConsulta(e) {

    if (e.target.checked) {
      this.listaProducionConsulta.sort((a, b) => a.numeral - b.numeral);
    }

  }

  onAm1(valor: number) {
    // this.periodo();
    this.listaProducion.forEach(element => {

      element.periodo =
        Number.parseFloat(this.validarNumeros(element.am1)) +
        Number.parseFloat(this.validarNumeros(element.pm1.toString())) +
        Number.parseFloat(this.validarNumeros(element.am2.toString())) +
        Number.parseFloat(this.validarNumeros(element.pm2.toString())) +
        Number.parseFloat(this.validarNumeros(element.am3.toString())) +
        Number.parseFloat(this.validarNumeros(element.pm3.toString())) +
        Number.parseFloat(this.validarNumeros(element.am4.toString())) +
        Number.parseFloat(this.validarNumeros(element.pm4.toString())) +
        Number.parseFloat(this.validarNumeros(element.am5.toString())) +
        Number.parseFloat(this.validarNumeros(element.pm5.toString())) +
        Number.parseFloat(this.validarNumeros(element.am6.toString())) +
        Number.parseFloat(this.validarNumeros(element.pm6.toString())) +
        Number.parseFloat(this.validarNumeros(element.am7.toString())) +
        Number.parseFloat(this.validarNumeros(element.pm7.toString()));

    });
  }



  periodo() {
    this.listaProducion.forEach(item => {
      this.hoja = new HojaModule();
      this.hoja = item;
      this.hoja.periodo = this.hoja.am1 + this.hoja.am2 + this.hoja.am3 + this.hoja.am4 + this.hoja.am5 + this.hoja.am6 + this.hoja.am7
        + this.hoja.pm1 + this.hoja.pm2 + this.hoja.pm3 + this.hoja.pm4 +
        this.hoja.pm5 + this.hoja.pm6 + this.hoja.pm7;
      item.periodo = this.hoja.periodo;

    });
  }


  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      this.listaProducion = [];
      const bstr: string = e.target.result;
      const data = <any[]>this.excelSrv.importFromFile(bstr);
      this.version = data[2][0];
      console.log(this.version);
      this.numeral = 0;
      for (let i = 4; i < data.length; i++) {
        let row = data[i];
        console.log(row);
        this.hoja = new HojaModule();
        if (row.length == 40) {
          for (let j = 0; j < row.length; j++) {
            if (j == 0) {
              this.hoja.codigo = row[j];
            }
            if (j == 1) {
              this.hoja.producto = row[j];
            }
            if (j == 2) {
              if (typeof row[j] === "undefined") {
                this.hoja.fm = 0;
              } else {
                this.hoja.fm = row[j];
              }
            }
            if (j == 3) {
              if (typeof row[j] === "undefined") {
                this.hoja.am1 = 0;
              } else {
                this.hoja.am1 = row[j];
              }
            }
            if (j == 5) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm1 = 0;
              } else {
                this.hoja.pm1 = row[j];
              }
            }
            if (j == 8) {
              if (typeof row[j] === "undefined") {
                this.hoja.am2 = 0;
              } else {
                this.hoja.am2 = row[j];
              }
            }
            if (j == 10) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm2 = 0;
              } else {
                this.hoja.pm2 = row[j];
              }
            }
            if (j == 13) {
              if (typeof row[j] === "undefined") {
                this.hoja.am3 = 0;
              } else {
                this.hoja.am3 = row[j];
              }
            }
            if (j == 15) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm3 = 0;
              } else {
                this.hoja.pm3 = row[j];
              }
            }
            if (j == 18) {
              if (typeof row[j] === "undefined") {
                this.hoja.am4 = 0;
              } else {
                this.hoja.am4 = row[j];
              }
            }
            if (j == 20) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm4 = 0;
              } else {
                this.hoja.pm4 = row[j];
              }
            }
            if (j == 23) {
              if (typeof row[j] === "undefined") {
                this.hoja.am5 = 0;
              } else {
                this.hoja.am5 = row[j];
              }
            }
            if (j == 25) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm5 = 0;
              } else {
                this.hoja.pm5 = row[j];
              }
            }
            if (j == 28) {
              if (typeof row[j] === "undefined") {
                this.hoja.am6 = 0;
              } else {
                this.hoja.am6 = row[j];
              }
            }
            if (j == 30) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm6 = 0;
              } else {
                this.hoja.pm6 = row[j];
              }
            }
            if (j == 33) {
              if (typeof row[j] === "undefined") {
                this.hoja.am7 = 0;
              } else {
                this.hoja.am7 = row[j];
              }
            }
            if (j == 35) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm7 = 0;
              } else {
                this.hoja.pm7 = row[j];
              }
            }
            if (j == 38) {
              if (typeof row[j] === "undefined") {
                this.hoja.periodo = 0;
              } else {
                this.hoja.periodo = row[j];
              }
            }

            if (j == 39) {
              if (typeof row[j] === "undefined") {
                this.hoja.categoria = '';
              } else {
                this.hoja.categoria = row[j];
              }
            }

          }
          this.hoja.numeral = this.numeral;
          this.numeral = this.numeral + 1;
          this.listaProducion.push(this.hoja);


        }
        this.mdbTable.setDataSource(this.listaProducion);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      }
      console.log(this.listaProducion);

      const header: string[] = Object.getOwnPropertyNames(new HojaModule());
      const importedData = data.slice(1, -1);

      this.importHoja = importedData.map(arr => {
        const obj = {};
        for (let i = 3; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
          //console.log(arr[i]);
        }
        return <HojaModule>obj;
      })

    };
    // console.log(this.importHoja);
    reader.readAsBinaryString(target.files[0]);

  }



  onFileChangeHojaLocales(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      this.listaProducionLocales = [];

      const bstr: string = e.target.result;
      const data = <any[]>this.excelSrv.importFromFile(bstr);
      this.version = data[2][0];
      console.log(this.version);
      this.numeral = 0;
      for (let i = 2; i < data.length; i++) {
        let row = data[i];
        console.log(row);
        this.hojaLocales = new HojaModule();
        for (let j = 0; j < row.length; j++) {
          if (j == 1) {
            this.hojaLocales.codigo = row[j];
          }
          if (j == 0) {
            this.hojaLocales.codigoInterno = row[j];
          }
          if (j == 2) {
            this.hojaLocales.producto = row[j];
          }
          //Lunes
          if (j == 3) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.am1 = 0;
            } else {
              this.hojaLocales.am1 = row[j];
            }
          }
          if (j == 4) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.amval1 = 0;
            } else {
              this.hojaLocales.amval1 = row[j];
            }
          }
          if (j == 5) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.pm1 = 0;
            } else {
              this.hojaLocales.pm1 = row[j];
            }
          }
          if (j == 6) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.valpm1 = 0;
            } else {
              this.hojaLocales.valpm1 = row[j];
            }
          }
          if (j == 7) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.dev1 = 0;
            } else {
              this.hojaLocales.dev1 = row[j];
            }
          }
          //Martes
          if (j == 8) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.am2 = 0;
            } else {
              this.hojaLocales.am2 = row[j];
            }
          }
          if (j == 9) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.valam2 = 0;
            } else {
              this.hojaLocales.valam2 = row[j];
            }
          }
          if (j == 10) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.pm2 = 0;
            } else {
              this.hojaLocales.pm2 = row[j];
            }
          }
          if (j == 11) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.valpm2 = 0;
            } else {
              this.hojaLocales.valpm2 = row[j];
            }
          }
          if (j == 12) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.dev2 = 0;
            } else {
              this.hojaLocales.dev2 = row[j];
            }
          }


          //Miercoles
          if (j == 13) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.am3 = 0;
            } else {
              this.hojaLocales.am3 = row[j];
            }
          }
          if (j == 14) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.amval3 = 0;
            } else {
              this.hojaLocales.amval3 = row[j];
            }
          }
          if (j == 15) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.pm3 = 0;
            } else {
              this.hojaLocales.pm3 = row[j];
            }
          }
          if (j == 16) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.valpm3 = 0;
            } else {
              this.hojaLocales.valpm3 = row[j];
            }
          }
          if (j == 17) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.dev3 = 0;
            } else {
              this.hojaLocales.dev3 = row[j];
            }
          }


          //Jueves
          if (j == 18) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.am4 = 0;
            } else {
              this.hojaLocales.am4 = row[j];
            }
          }
          if (j == 19) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.amval4 = 0;
            } else {
              this.hojaLocales.amval4 = row[j];
            }
          }
          if (j == 20) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.pm4 = 0;
            } else {
              this.hojaLocales.pm4 = row[j];
            }
          }
          if (j == 21) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.valpm4 = 0;
            } else {
              this.hojaLocales.valpm4 = row[j];
            }
          }
          if (j == 22) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.dev4 = 0;
            } else {
              this.hojaLocales.dev4 = row[j];
            }
          }

          //Viernes
          if (j == 23) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.am5 = 0;
            } else {
              this.hojaLocales.am5 = row[j];
            }
          }
          if (j == 24) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.amval5 = 0;
            } else {
              this.hojaLocales.amval5 = row[j];
            }
          }
          if (j == 25) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.pm5 = 0;
            } else {
              this.hojaLocales.pm5 = row[j];
            }
          }
          if (j == 26) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.valpm5 = 0;
            } else {
              this.hojaLocales.valpm5 = row[j];
            }
          }
          if (j == 27) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.dev5 = 0;
            } else {
              this.hojaLocales.dev5 = row[j];
            }
          }


          //Sabado
          if (j == 28) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.am6 = 0;
            } else {
              this.hojaLocales.am6 = row[j];
            }
          }
          if (j == 29) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.amval6 = 0;
            } else {
              this.hojaLocales.amval6 = row[j];
            }
          }
          if (j == 30) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.pm6 = 0;
            } else {
              this.hojaLocales.pm6 = row[j];
            }
          }
          if (j == 31) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.valpm6 = 0;
            } else {
              this.hojaLocales.valpm6 = row[j];
            }
          }
          if (j == 32) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.dev6 = 0;
            } else {
              this.hojaLocales.dev6 = row[j];
            }
          }

          //Domingo
          if (j == 33) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.amval7 = 0;
            } else {
              this.hojaLocales.am7 = row[j];
            }
          }
          if (j == 34) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.amval7 = 0;
            } else {
              this.hojaLocales.amval7 = row[j];
            } 
          }
          if (j == 35) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.pm7 = 0;
            } else {
              this.hojaLocales.pm7 = row[j];
            }
          }
          if (j == 36) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.valpm7 = 0;
            } else {
              this.hojaLocales.valpm7 = row[j];
            }
          }
          if (j == 37) {
            if (typeof row[j] === "undefined") {
              this.hojaLocales.dev7 = 0;
            } else {
              this.hojaLocales.dev7 = row[j];
            }
          }
        }
        let anio = new Date().getFullYear();
        console.log('Anio '+new Date().getFullYear());
        this.hojaLocales.id_local = Number.parseInt(this.idLocal);
       
        this.hojaLocales.semana = this.perValor;
        this.hojaLocales.anio=Number.parseInt(this.fechaHoja.substring(0,4)) 
        this.hojaLocales.id_pais = Number.parseInt(this.id_pais);
        //this.hojaLocales.anio = (new Date()).getFullYear();
        this.listaProducionLocales.push(this.hojaLocales);
       

      }

      this.confirmacionActualizarLocal();
      

      const header: string[] = Object.getOwnPropertyNames(new HojaModule());
      const importedData = data.slice(1, -1);

      this.importHoja = importedData.map(arr => {
        const obj = {};
        for (let i = 3; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
          //console.log(arr[i]);
        }
        return <HojaModule>obj;
      })

    };
    // console.log(this.importHoja);
    reader.readAsBinaryString(target.files[0]);

  }
  confirmacionActualizarLocal() {
    Swal.fire({
      title: 'Desea actualizar la información del local?',
      text: 'Se cargo con exito la información.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.apiHoja.actualizarProduccionLocales(this.listaProducionLocales).subscribe((
          data) => {
    
            Swal.fire('Procesado!', 'Actualización con exito...', 'success');
            this.listaProducionLocales=[];  
    
        },
          err =>
            this.alertService.close(err)
        )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.listaProducionLocales=[];  
        Swal.fire('Cancelo', 'Se cancelo la actualización...', 'error');
      }
    });
  }
  buscarProducciones() {
    this.listarVersionesLocales();
    this.version = "";


    this.apiHoja.listarProduccionTodos(this.idLocal, this.fecha, this.id_pais)
      .subscribe((
        data: HojaModule[]) => {
        this.listaProducion = data;
        this.listaProducion.forEach(element => {
          this.version = element.version;
          element.periodo =
            Number.parseFloat(element.am1.toString()) +
            Number.parseFloat(element.pm1.toString()) +
            Number.parseFloat(element.am2.toString()) +
            Number.parseFloat(element.pm2.toString()) +
            Number.parseFloat(element.am3.toString()) +
            Number.parseFloat(element.pm3.toString()) +
            Number.parseFloat(element.am4.toString()) +
            Number.parseFloat(element.pm4.toString()) +
            Number.parseFloat(element.am5.toString()) +
            Number.parseFloat(element.pm5.toString()) +
            Number.parseFloat(element.am6.toString()) +
            Number.parseFloat(element.pm6.toString()) +
            Number.parseFloat(element.am7.toString()) +
            Number.parseFloat(element.pm7.toString());

        });
        console.log(data)
        this.mdbTable.setDataSource(this.listaProducion);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }
}
